import { render, staticRenderFns } from "./EducationFormModal.vue?vue&type=template&id=ca829f06"
import script from "./EducationFormModal.vue?vue&type=script&lang=js"
export * from "./EducationFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports